export default __webpack_public_path__ + "static/media/award-2.c5a576c2.webp";